export default __webpack_public_path__ + "static/media/team-picture.ea2fdb6e.jpg";